'use client';

import { type CSSProperties, useMemo } from 'react';

import type { ResponsiveColumns } from './types';

function rowsInColumn(itemCount: number, columnCount: number) {
    const columns = Math.max(1, columnCount);

    return Math.max(1, Math.ceil(itemCount / columns));
}

/** Row counts keep each item in a fixed cell. CSS media queries choose which count is active. */
export function useFaqColumns(itemCount: number, columns?: ResponsiveColumns) {
    return useMemo((): CSSProperties | undefined => {
        if (!columns) {
            return undefined;
        }

        return {
            '--faq-rows-tablet': rowsInColumn(itemCount, columns.tablet),
            '--faq-rows-desktop': rowsInColumn(itemCount, columns.desktop),
        } as CSSProperties;
    }, [columns, itemCount]);
}
